import { ArrowCounterClockwiseIcon, HouseIcon } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import QuizrrErrorSvg from '../../../../apps/frontend/public/img/quizrr-error.svg';
import { useNavigate } from 'react-router-dom';

const ErrorPage = ({ errorCode, resetErrorBoundary }) => {
  const navigate = useNavigate();
  const getErrorTitle = (errorCode) => {
    switch (errorCode) {
      case 404:
        return 'Page Not Found';
      case 503:
        return "It's not you, it's us";
      default:
        return 'Something went wrong';
    }
  };

  const getErrorName = (errorCode) => {
    switch (errorCode) {
      case 404:
        return '404 ERROR';
      case 503:
        return 'SERVER ERROR';
      default:
        return '500';
    }
  };

  const getErrorDescription = (errorCode) => {
    switch (errorCode) {
      case 404:
        return (
          <>
            The page you’re looking for doesn’t exist or may have been moved.
            <br />
            Please check the link or return to the homepage to continue learning.
          </>
        );

      case 503:
        return (
          <>
            Looks like our server is doing a quick warm-up round.
            <br />
            Don’t worry — just like you, it’ll come back stronger 💪
          </>
        );
      default:
        return 'Something went wrong';
    }
  };

  const getErrorButton = (errorCode) => {
    switch (errorCode) {
      case 404:
        return (
          <Button
            className="bg-[var(--q3-accent-normal)] flex flex-row items-center gap-2 p-2 rounded-full w-[200px] h-10"
            onClick={() => navigate('/v2/home')}
          >
            <HouseIcon size={22} className="text-[var(--q3-neutral-default_inverted)]" />
            Go Home
          </Button>
        );
      case 503:
        return (
          <Button
            className="bg-[var(--q3-accent-normal)] flex flex-row items-center gap-2 p-2 rounded-full w-[200px] h-10"
            onClick={() => resetErrorBoundary()}
          >
            <ArrowCounterClockwiseIcon size={22} className="text-[var(--q3-neutral-default_inverted)]" />
            Reload
          </Button>
        );
      default:
        return 'Return to Home';
    }
  };

  return (
    <div className="relative flex flex-col h-screen items-center justify-center gap-4">
      <p className="text-[var(--q3-accent-normal)] text-sm md:text-base">{getErrorName(errorCode)}</p>
      <p className="text-2xl md:text-4xl font-bold text-[var(--q3-neutral-default)]">{getErrorTitle(errorCode)}</p>
      <p className="text-[var(--q3-neutral-light)] text-center text-sm md:text-base">
        {getErrorDescription(errorCode)}
      </p>
      <div className="mt-8">{getErrorButton(errorCode)}</div>
      <p className="text-center text-xs">
        If the issue continues please write an email
        <br />
        at{' '}
        <a
          className="text-[var(--q3-accent-normal)]"
          href={`mailto:support@mathongo.com?subject=error_${errorCode}&body=Page Url: ${window.location.href}`}
        >
          support@mathongo.com
        </a>
      </p>
      <div className="absolute bottom-0">
        <img src={QuizrrErrorSvg} alt="Quizrr" />
      </div>
    </div>
  );
};

export default ErrorPage;
